/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { QuoteAcceptanceBlockingReason } from './';
import {
    QuoteAcceptanceBlockingReasonFromJSON,
    QuoteAcceptanceBlockingReasonFromJSONTyped,
    QuoteAcceptanceBlockingReasonToJSON,
} from './';
import type { QuotePunchoutResource } from './';
import {
    QuotePunchoutResourceFromJSON,
    QuotePunchoutResourceFromJSONTyped,
    QuotePunchoutResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuoteOptionsResource
 */
export interface QuoteOptionsResource {
    /**
     * 
     * @type {boolean}
     * @memberof QuoteOptionsResource
     */
    canAcceptQuote: boolean;
    /**
     * 
     * @type {QuoteAcceptanceBlockingReason}
     * @memberof QuoteOptionsResource
     */
    acceptanceBlockingReason?: QuoteAcceptanceBlockingReason;
    /**
     * 
     * @type {boolean}
     * @memberof QuoteOptionsResource
     */
    shouldDisplayFees: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuoteOptionsResource
     */
    needPreAcceptation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuoteOptionsResource
     */
    needClientPurchaseOrder: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuoteOptionsResource
     */
    needClientPhoneNumber: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuoteOptionsResource
     */
    needClientBillingInformation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuoteOptionsResource
     */
    isOpenQuote: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuoteOptionsResource
     */
    isFreelancerVerificationBypassed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuoteOptionsResource
     */
    isFreelancerRecentlyVerified: boolean;
    /**
     * 
     * @type {QuotePunchoutResource}
     * @memberof QuoteOptionsResource
     */
    punchout: QuotePunchoutResource;
    /**
     * 
     * @type {boolean}
     * @memberof QuoteOptionsResource
     */
    isPrepayment: boolean;
}

/**
 * Check if a given object implements the QuoteOptionsResource interface.
 */
export function instanceOfQuoteOptionsResource(value: object): value is QuoteOptionsResource {
    if (!('canAcceptQuote' in value) || value['canAcceptQuote'] === undefined) return false;
    if (!('shouldDisplayFees' in value) || value['shouldDisplayFees'] === undefined) return false;
    if (!('needPreAcceptation' in value) || value['needPreAcceptation'] === undefined) return false;
    if (!('needClientPurchaseOrder' in value) || value['needClientPurchaseOrder'] === undefined) return false;
    if (!('needClientPhoneNumber' in value) || value['needClientPhoneNumber'] === undefined) return false;
    if (!('needClientBillingInformation' in value) || value['needClientBillingInformation'] === undefined) return false;
    if (!('isOpenQuote' in value) || value['isOpenQuote'] === undefined) return false;
    if (!('isFreelancerVerificationBypassed' in value) || value['isFreelancerVerificationBypassed'] === undefined) return false;
    if (!('isFreelancerRecentlyVerified' in value) || value['isFreelancerRecentlyVerified'] === undefined) return false;
    if (!('punchout' in value) || value['punchout'] === undefined) return false;
    if (!('isPrepayment' in value) || value['isPrepayment'] === undefined) return false;
    return true;
}

export function QuoteOptionsResourceFromJSON(json: any): QuoteOptionsResource {
    return QuoteOptionsResourceFromJSONTyped(json, false);
}

export function QuoteOptionsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteOptionsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'canAcceptQuote': json['canAcceptQuote'],
        'acceptanceBlockingReason': json['acceptanceBlockingReason'] == null ? undefined : QuoteAcceptanceBlockingReasonFromJSON(json['acceptanceBlockingReason']),
        'shouldDisplayFees': json['shouldDisplayFees'],
        'needPreAcceptation': json['needPreAcceptation'],
        'needClientPurchaseOrder': json['needClientPurchaseOrder'],
        'needClientPhoneNumber': json['needClientPhoneNumber'],
        'needClientBillingInformation': json['needClientBillingInformation'],
        'isOpenQuote': json['isOpenQuote'],
        'isFreelancerVerificationBypassed': json['isFreelancerVerificationBypassed'],
        'isFreelancerRecentlyVerified': json['isFreelancerRecentlyVerified'],
        'punchout': QuotePunchoutResourceFromJSON(json['punchout']),
        'isPrepayment': json['isPrepayment'],
    };
}

export function QuoteOptionsResourceToJSON(value?: QuoteOptionsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'canAcceptQuote': value['canAcceptQuote'],
        'acceptanceBlockingReason': QuoteAcceptanceBlockingReasonToJSON(value['acceptanceBlockingReason']),
        'shouldDisplayFees': value['shouldDisplayFees'],
        'needPreAcceptation': value['needPreAcceptation'],
        'needClientPurchaseOrder': value['needClientPurchaseOrder'],
        'needClientPhoneNumber': value['needClientPhoneNumber'],
        'needClientBillingInformation': value['needClientBillingInformation'],
        'isOpenQuote': value['isOpenQuote'],
        'isFreelancerVerificationBypassed': value['isFreelancerVerificationBypassed'],
        'isFreelancerRecentlyVerified': value['isFreelancerRecentlyVerified'],
        'punchout': QuotePunchoutResourceToJSON(value['punchout']),
        'isPrepayment': value['isPrepayment'],
    };
}

